import CryptoJS from 'crypto-js';

// .env values are copied from Angular's environment.ts which uses trailing commas
// (e.g. value: 'abc',). CRA's dotenv v10 only strips quotes when the last char IS
// a quote — the trailing comma breaks that check, so we strip manually.
const stripEnvValue = (val: string | undefined): string =>
  (val ?? '').replace(/^['"]/, '').replace(/['"],?$/, '');

const secretKey = stripEnvValue(process.env.REACT_APP_API_cryptoSecretKey);
const initialVector = stripEnvValue(process.env.REACT_APP_API_initialVector);

// CryptoJS mutates WordArray objects during AES operations (IV chaining in CBC mode),
// so fresh instances must be created per call — never share a single parsed WordArray.
const getKey = () => CryptoJS.enc.Utf8.parse(secretKey);
const getIV = () => CryptoJS.enc.Utf8.parse(initialVector);

const getConfig = () => ({
  iv: getIV(),
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7,
});

export interface EncryptedPayload {
  records: string;
}

export interface DecryptedResponse {
  result: string;
}

export const encryptData = (data: unknown): EncryptedPayload => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    getKey(),
    getConfig()
  );
  return { records: encrypted.toString() };
};

export const decryptData = <T = unknown>(data: DecryptedResponse): T => {
  const decrypted = CryptoJS.AES.decrypt(data.result, getKey(), getConfig());
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)) as T;
};
